import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';

import pdf1 from '../pamphlets/APPROVED-What_is_an_Orthodontist_Flyer-NEW-LOGO-2011.pdf';
import pdf2 from '../pamphlets/Problems_Growing_Children-12-l.pdf';
import pdf3 from '../pamphlets/Problems-Watch-7yr-olds-09-l.pdf';
import pdf4 from '../pamphlets/Problems-to-Watch-Adults-r-l.pdf';
import pdf5 from '../pamphlets/AAO_Dental_Trauma_Flyer_FINAL-NEW-LOGO-2011.pdf';

class pamphlet {
    constructor(title, file) {
        this.title = title;
        this.file = file;
    }
    title;
    file;
}

export class Pamphlet extends Component {
    pdfs = [
        new pamphlet('What is an Orthodontists?', pdf1),
        new pamphlet('The Right Time for an Orthodontic Check-Up: No Later than Age 7', pdf2),
        new pamphlet('American Association of Orthodontists Recommendation For Orthodontic Check-Ups No Later than Age 7',
            pdf3),
        new pamphlet('The American Association of Orthodontists Recommends Treatment for Adults, When Appropriate, in Conjunction with Regular Dental Care',
            pdf4),
        new pamphlet('Prevent Accidents: But Know What To Do If One Occurs', pdf5),
    ];

    render() {
        return (<Container fluid className="content">
            <Row>
                <Col className="title">
                    <h1>Pamphlets & Information</h1>
                </Col>
            </Row>
            <Row>
                <Col sm="1" md="2" lg="3"></Col>
                <Col sm="10" md="8" lg="6">
                    <ul style={{ "list-style": "none" }}>
                        {this.pdfs.map(p =>
                            <li class="pamphlet"><a href={p.file} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faBook} /> {p.title}</a></li>
                        )}
                    </ul>
                </Col>
                <Col sm="1" md="2" lg="3"></Col>
            </Row>
        </Container >);
    }
}
